import { render, staticRenderFns } from "./OrderGoods.vue?vue&type=template&id=416c1fd8&scoped=true&"
import script from "./OrderGoods.vue?vue&type=script&lang=js&"
export * from "./OrderGoods.vue?vue&type=script&lang=js&"
import style0 from "./OrderGoods.vue?vue&type=style&index=0&id=416c1fd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416c1fd8",
  null
  
)

export default component.exports